module.exports = "mat-header-row.mat-header-row{display:none}.mat-card{padding:0 24px 24px 24px}\n"